import { Expose } from 'class-transformer';

export class ClientAvailabilityDto {
  @Expose()
  uuid: string;

  @Expose()
  startTime: string;

  @Expose()
  endTime: string;

  @Expose()
  dateFrom: string;

  @Expose()
  dateTo: string;

  @Expose()
  clientUuid: string;

  @Expose()
  teletherapyMode: boolean;

  @Expose()
  inHomeMode: boolean;

  @Expose()
  weekday: string[];

  @Expose()
  note: string;

  @Expose()
  createdAt: string;

  @Expose()
  updatedAt: boolean;
}
